export enum Type {
  MAIN = 'Main Footer',
  CHECKOUT = 'Checkout Footer'
}
